import React, { useState, useEffect } from 'react';

// Simulated system data
const mockSystems = [
  {
    id: 201,
    name: 'Hospital Management System',
    category: 'Operations',
    description: 'End-to-end platform for managing hospital workflows, patient records, and billing.',
    demoVideo: 'https://example.com/hms-demo.mp4',
    adoptionStats: 'Used by 120+ institutions',
    price: '$199',
  },
  {
    id: 202,
    name: 'Clinical Audit Tracker',
    category: 'Governance',
    description: 'Tool for tracking clinical audits, compliance, and corrective actions.',
    demoVideo: '',
    adoptionStats: 'Adopted by 60+ clinics',
    price: '$149',
  },
  // Add more systems as needed
];

export default function SystemsOverviewComponent() {
  const [systems, setSystems] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    setSystems(mockSystems);
    setFiltered(mockSystems);
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearch(term);
    setFiltered(
      systems.filter(
        (s) =>
          s.name.toLowerCase().includes(term) ||
          s.category.toLowerCase().includes(term)
      )
    );
  };

  const handleDownload = (system) => {
    setSelectedSystem(system);
    setShowForm(true);
  };

  return (
    <div className="max-w-6xl mx-auto px-6 py-8 bg-gray-100">
      <h1 className="text-3xl font-bold mb-4">Healthcare Systems Overview</h1>
      <p className="mb-6 text-gray-700">
        Explore IPSA’s healthcare management systems. Registration, verification, personalization, and payment are required before download.
      </p>

      <input
        type="text"
        placeholder="Search systems by name or category"
        value={search}
        onChange={handleSearch}
        className="mb-6 w-full p-2 border rounded"
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {filtered.map((system) => (
          <div key={system.id} className="border p-4 rounded shadow">
            <h2 className="text-xl font-semibold">{system.name}</h2>
            <p className="text-sm text-gray-600">{system.category}</p>
            <p className="mt-2">{system.description}</p>
            <p className="text-xs text-gray-500 mt-1">
              {system.adoptionStats}
            </p>
            {system.demoVideo && (
              <video controls className="mt-4 w-full rounded">
                <source src={system.demoVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
            <p className="text-md font-bold mt-2">Price: {system.price}</p>
            <button
              onClick={() => handleDownload(system)}
              className="mt-4 bg-indigo-600 text-white px-4 py-2 rounded"
            >
              Personalize & Purchase
            </button>
          </div>
        ))}
      </div>

      {showForm && selectedSystem && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg max-w-md w-full">
            <h3 className="text-xl font-bold mb-4">
              Personalize & Purchase: {selectedSystem.name}
            </h3>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                alert('Redirecting to payment gateway...');
                setShowForm(false);
              }}
            >
              <label className="block mb-2">
                Institution Name:
                <input type="text" required className="w-full p-2 border rounded" />
              </label>
              <label className="block mb-2">
                Contact Email:
                <input type="email" required className="w-full p-2 border rounded" />
              </label>
              <label className="block mb-4">
                Intended Use:
                <textarea required className="w-full p-2 border rounded" />
              </label>
              <div className="flex justify-end gap-4">
                <button
                  type="button"
                  onClick={() => setShowForm(false)}
                  className="px-4 py-2 bg-gray-300 rounded"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-600 text-white rounded"
                >
                  Proceed to Payment
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
